import { render, staticRenderFns } from "./shopForeignForm.vue?vue&type=template&id=15636d40&scoped=true"
import script from "./shopForeignForm.vue?vue&type=script&lang=js"
export * from "./shopForeignForm.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./shopForeignForm.vue?vue&type=style&index=1&id=15636d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15636d40",
  null
  
)

export default component.exports